import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TITLES = {
  "/": "May Forward Tech — AI Strategy, Development & Digital Transformation",
  "/services": "Services — May Forward Tech",
  "/case-studies": "Case Studies — May Forward Tech",
  "/process": "Our Process — May Forward Tech",
  "/contact": "Contact — May Forward Tech",
  "/about": "About — May Forward Tech",
};

export function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname.startsWith("/services/") && TITLES[pathname]) {
      document.title = TITLES[pathname];
    }
  }, [pathname]);
  return null;
}
